export default "__VITE_ASSET__DlKuJqGo__"